import { Button } from '@mui/material';
import { Descriptions, Spin } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import React, { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from 'react-to-print';
import PosReportContext from '../../contexts/pos-report-context/PosReportContext';
import './PosReportModal.scss';
import ShiftReportsContext from '../../contexts/shift-reports-context/ShiftReportsContext';

const PosReportModal = () => {
  const componentRef = useRef();
  const { t } = useTranslation();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `
      @media print {
      html, body { height: initial !important; overflow: initial !important; }

      tbody { display: table-row-group !important; }
      thead {
        display: table-row-group !important;
      }
      tfoot {
        display: table-row-group !important;
      }
      @page {
        size: auto;
        margin: none;
      }
      .qr-code-wrap canvas {
        width: 94px !important;
        height: 94px !important;
      }
      .pagebreak {
        display: block;
        size: auto;
      }
      .invoice-details-wrap {
        padding: 0;
      }
      .ant-descriptions-item-content,
        .ant-descriptions-item-label {
          padding: 4px 12px !important;
        }
      }
      .ant-descriptions-header {
        margin: 4px 0 !important;
      }
      .models-title {
        direction: rtl;
        color: rgba(0, 0, 0, 0.9);
        font-weight: bold;
        fontSize: 16px;
        margin-top: 14px;
        margin-bottom: 8px;
      }
      .ant-table-wrapper {
        border-top: 1px solid rgba(0, 0, 0, 0.08);
      }
      th {
        color: rgba(0, 0, 0, 0.85) !important;
      }
      .invoice-extra-prices-table .ant-table-cell {
        padding: 4px 12px !important;
        text-align: right;
      }
    `
  });
  const { posReportIsLoading } = useContext(PosReportContext);

  const {
    selectedShiftReportsModalOpned,
    setSelectedShiftReportsModalOpened,
    selectedShiftReport
  } = useContext(ShiftReportsContext);
  const renderReportDetails = () => {
    return (
      <div className="report-modal-content" ref={componentRef}>
        <Descriptions title={t('ShiftReport.EmployeeData')} bordered column={1}>
          {selectedShiftReport.employee?.name && (
            <Descriptions.Item label={t('ShiftReport.EmployeeName')}>
              {selectedShiftReport.employee.name}
            </Descriptions.Item>
          )}
          {selectedShiftReport.employee?.phone && (
            <Descriptions.Item label={t('ShiftReport.PhoneNumber')}>
              {selectedShiftReport.employee.phone}
            </Descriptions.Item>
          )}
        </Descriptions>

        <Descriptions
          style={{ marginTop: 14 }}
          title={t('ShiftReport.PointOfSaleData')}
          bordered
          column={1}
        >
          {selectedShiftReport.pos?.name && (
            <Descriptions.Item label={t('ShiftReport.PointOfSale')}>
              {selectedShiftReport.pos.name}
            </Descriptions.Item>
          )}
          {/* {selectedShiftReport.pos?.balance && (
            <Descriptions.Item label={t('ShiftReport.TotalCashAccount')}>
              {selectedShiftReport.pos.balance}
            </Descriptions.Item>
          )}
          {selectedShiftReport.pos?.cash && (
            <Descriptions.Item label={t('ShiftReport.CashAccount')}>
              {selectedShiftReport.pos.cash}
            </Descriptions.Item>
          )}
          {selectedShiftReport.pos?.visa && (
            <Descriptions.Item label={t('ShiftReport.CreditCardAccount')}>
              {selectedShiftReport.pos.visa}
            </Descriptions.Item>
          )} */}
        </Descriptions>

        <Descriptions
          style={{ marginTop: 14 }}
          title={t('ShiftReport.ShiftData')}
          bordered
          column={1}
        >
          {selectedShiftReport.start_shift && (
            <Descriptions.Item label={t('ShiftReport.ShiftStart')}>
              {selectedShiftReport.start_shift}
            </Descriptions.Item>
          )}
          {selectedShiftReport.end_shift && (
            <Descriptions.Item label={t('ShiftReport.ShiftEnd')}>
              {selectedShiftReport.end_shift}
            </Descriptions.Item>
          )}
          {selectedShiftReport.shiftCash && (
            <Descriptions.Item label={t('ShiftReport.Cash')}>
              {selectedShiftReport.shiftCash}
            </Descriptions.Item>
          )}
          {selectedShiftReport.shiftVisa && (
            <Descriptions.Item label={t('ShiftReport.Credit')}>
              {selectedShiftReport.shiftVisa}
            </Descriptions.Item>
          )}
          
          {selectedShiftReport?.shiftDeferred && (
            <Descriptions.Item label={t('ShiftReports.deferred')}>
              {selectedShiftReport.shiftDeferred}
            </Descriptions.Item>
          )}
          {selectedShiftReport?.shiftBank && (
            <Descriptions.Item label={t('ShiftReport.shiftBank')}>
              {selectedShiftReport.shiftBank}
            </Descriptions.Item>
          )}
          {selectedShiftReport?.shiftMoney && (
            <Descriptions.Item label={t('ShiftReport.TillAccount')}>
              {selectedShiftReport?.shiftMoney}
            </Descriptions.Item>
          )}
          {selectedShiftReport?.totalAmount && (
            <Descriptions.Item label={t('ShiftReport.TotalAccount')}>
              {parseFloat(selectedShiftReport?.totalAmount).toFixed(2)}
            </Descriptions.Item>
          )}
        </Descriptions>

        <Descriptions
          style={{ marginTop: 14 }}
          title={t('ShiftReport.ShiftEndData')}
          bordered
          column={1}
        >
          {/* {selectedShiftReport.start_shift && (
            <Descriptions.Item label={t('ShiftReport.OpeningDate')}>
              {selectedShiftReport.start_shift}
            </Descriptions.Item>
          )}
          {selectedShiftReport.end_shift && (
            <Descriptions.Item label="تاريخ الغلق">
              {selectedShiftReport.end_shift}
            </Descriptions.Item>
          )} */}
          {selectedShiftReport.first_invoice_number && (
            <Descriptions.Item label={t('ShiftReport.Firstinvoicenumber')}>
              {selectedShiftReport.first_invoice_number}
            </Descriptions.Item>
          )}
          {selectedShiftReport.last_invoice_number && (
            <Descriptions.Item label={t('ShiftReport.endinvoicenumber')}>
              {selectedShiftReport.last_invoice_number}
            </Descriptions.Item>
          )}
          {selectedShiftReport?.return_amount && (
            <Descriptions.Item label={t('ShiftReport.ReturnValue')}>
              {parseFloat(selectedShiftReport?.return_amount).toFixed(2)}
            </Descriptions.Item>
          )}
          {selectedShiftReport?.invoices_count && (
            <Descriptions.Item label={t('ShiftReport.InvoiceCount')}>
              {selectedShiftReport?.invoices_count}
            </Descriptions.Item>
          )}
        </Descriptions>
        {/* <div className="end-shift">
          <span
            onClick={() => {
              setEndTheShit(true);
            }}
            className="end-shift-btn"
          >
            {t('ShiftReport.ShiftFinished')}
          </span>
        </div> */}
      </div>
    );
  };

  const renderModalContent = () => {
    if (!posReportIsLoading && selectedShiftReport) return renderReportDetails();
    else if (posReportIsLoading) {
      return (
        <div style={{ minHeight: 182, display: 'grid', placeItems: 'center' }}>
          <Spin />
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <Modal
      transitionName=""
      className="shared-custom-modal pos-report-modal"
      width="90%"
      style={{ maxWidth: '742px' }}
      title={
        <div className={'model-header model-header-pos'}>
          <h3>{t('ShiftReport.ShiftReport')}</h3>
          <div style={{ display: 'flex', gap: '12px' }}>
            <Button
              onClick={handlePrint}
              className="circled-btn"
              type="dashed"
              shape="circle"
            >
              {t('ShiftReport.PrintReport')}
            </Button>
            {/* <Button
              onClick={() => {
                setPosReportModalOpened(false);
                setPosBoxModalOpened(true);
              }}
              className="circled-btn"
              type="dashed"
              shape="circle"
            >
              {t('ShiftReport.OpenTill')}
            </Button> */}
          </div>
        </div>
      }
      visible={selectedShiftReportsModalOpned}
      onOk={() => {
        setSelectedShiftReportsModalOpened(false);
      }}
      onCancel={() => {
        setSelectedShiftReportsModalOpened(false);
      }}
      footer={false}
    >
      {renderModalContent()}
    </Modal>
  );
};

export default PosReportModal;
// ShiftReport.OpenTill
